import React, { useState, useEffect, useCallback, useRef } from "react";
import { connect } from 'react-redux'
import { BiEdit } from "react-icons/bi";
import { RiDeleteBin6Line } from "react-icons/ri";
import { Button, Form, Modal } from "react-bootstrap";
import AgGridTable from "../AgGridTable";
import { useForm } from "react-hook-form";
import {
    addSectorAction,
    updateSectorAction,
    deleteSectorAction
} from '../../../redux/actions/admin/adminAction';

export const Sector = (props) => {
    const gridRef = useRef();

    const [inputData, setInputData] = useState({ 'sector': '' })
    const [show, setShow] = useState(false);

    const handleShow = () => {
        setShow(true);
    }

    const handleClose = () => {
        setInputData({ 'sector': '' })
        setShow(false)
    };

    const handleChange = (event) => {
        setInputData((prevstate) => ({
            ...prevstate,
            [event.target.name]: event.target.value
        }))
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        if (inputData['id']) {
            props.updateSector(inputData.id, inputData)
            handleClose()
        }
        else {
            props.addSector(inputData)
            handleClose()
        }
    };

    const handleSetData = (data) => {
        setInputData(data)
        handleShow()
    }

    const handleDelete = (id) => {
        props.deleteSector(id)
    }


    const [sectorColumnDefs] = useState([
        { headerName: "Id", field: 'id', sort: 'asc' },
        { headerName: "Sector", field: 'sector', filter: true },
        {
            headerName: "Actions", field: 'action',
            cellRendererFramework: (params) => <>
                <BiEdit color="blue" size={20} onClick={() => handleSetData(params.data)} cursor='pointer' />
                <RiDeleteBin6Line color="red" size={20} onClick={() => handleDelete(params.data.id)} cursor='pointer' />
            </>,
            cellStyle: { textAlign: 'center' }
        },

    ])

    const defaultColDef = {
        flex: 1,
        floatingFilter: true,
        sortable: true,
        editable: false,
    }

    return (
        <div>
            <div align='right'>
                <button className="btn btn-blue"
                    onClick={() => handleShow()}
                    style={{ marginBottom: "10px" }}>Add</button>
            </div>

            <AgGridTable
                ref={gridRef}
                data={props.sector}
                defaultColDef={defaultColDef}
                columnDefs={sectorColumnDefs} />

            {/* Add Form */}
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Sector</Modal.Title>
                </Modal.Header>

                <form onSubmit={handleSubmit}>

                    <Modal.Body>
                        <h3>Sector</h3>
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                id="sector"
                                name="sector"
                                value={inputData.sector}
                                onChange={handleChange}
                                placeholder="Sector"
                                autoComplete="off"
                            />
                        </div>

                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}>
                            Cancel
                        </Button>
                        <Button variant="primary" type="submit">
                            Submit
                        </Button>
                    </Modal.Footer>

                </form>
            </Modal>
        </div >
    )
}

const mapStateToProps = (state) => {
    const sector = state.admin.sector;
    return {
        sector: sector,
    };
};

const mapDispatchToProps = (dispatch, state) => {
    return {
        addSector: (data) => dispatch(addSectorAction(data)),
        updateSector: (id, data) => dispatch(updateSectorAction(id, data)),
        deleteSector: (id) => dispatch(deleteSectorAction(id)),

    };
};



export default connect(mapStateToProps, mapDispatchToProps)(Sector)